let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2wngW")).then(() => parcelRequire('9gWGe'));